/**
 * A ticking clock hook. Returns `Date.now()` and re-renders on an interval so
 * time-derived UI (e.g. "online now" classification, "Xs ago" labels) stays
 * fresh even when no new Firestore snapshot arrives.
 */
import { useEffect, useState } from 'react';

export function useNow(intervalMs = 4000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
}
